<template>
  <div>
    <b-row>
      <b-col sm="12">
        <SelectOption :titleSize="14" :showButtonNext="false" size="small" :width="110" :height="42"
          :options="optionsWithByRules" v-model="generatePeriodRental.typePerid" />
      </b-col>
    </b-row>

    <Alert type="warning" v-if="optionsWithByRules.length === 0">
      <span>
        É necessário configurar o Display (Cálculo de Período) em Adm > Parâmetro > Locação!
      </span>
    </Alert>

    <div v-if="generatePeriodRental.typePerid != 0" class="period-row">
      <div class="increment-decrement">
        <IncrementDecrement :min="1" v-model="generatePeriodRental.multiplier" />
      </div>

      <div v-if="isShowStartDateHour" class="date-field-period">
        <DateTime field="purchaseDate" format="DD/MM/YYYY HH:mm" type="dateTime" placeholder :required="false"
          :markFormDirty="false" v-model="generatePeriodRental.startDateHour" />
      </div>

      <div class="btn-generate">
        <Button _key="btnGeneratePeriodRent" title="Gerar Período" classIcon="fa-solid fa-calendar-circle-plus"
          :disabled="btnGenerateDisabled" color="white" backGroundColor="#156EBE" size="medium" :clicked="generate" />
      </div>
    </div>

    <div class="div-period-rent" v-show="showPeriodRent">
      <PeriodRentItem />
    </div>
  </div>
</template>

<script>
import SelectOption from "@nixweb/nixloc-ui/src/component/shared/SelectOption.vue";
import IncrementDecrement from "@nixweb/nixloc-ui/src/component/forms/IncrementDecrement.vue";
import DateTime from "@nixweb/nixloc-ui/src/component/forms/DateTime";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";

import GeneratePeriodRental from "./GeneratePeriodRent.js";
import PeriodRentItem from "./PeriodRentItem.vue";

import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
  name: "GeneratePeriodRent",
  props: ["startDateHour", "isShowStartDateHour"], // removidos: formName, value
  components: {
    SelectOption,
    IncrementDecrement,
    DateTime,
    Button,
    Alert,
    PeriodRentItem,
  },
  data() {
    return {
      generatePeriodRental: new GeneratePeriodRental(),
      showPeriodRent: false,
      btnGenerateDisabled: true,
      urlGenerate: "/api/v1/rental/period-rent/generate",
      options: [
        { title: "Minuto", titleSize: "13", icon: "fa-solid fa-clock-eight", value: 1 },
        { title: "Hora", titleSize: "13", icon: "fa-solid fa-hourglass", value: 2 },
        { title: "Dia", titleSize: "13", icon: "fa-solid fa-calendar-day", value: 3 },
        { title: "Semana", titleSize: "13", icon: "fa-solid fa-calendar-week", value: 4 },
        { title: "Quinzena", titleSize: "13", icon: "fa-solid fa-calendar-lines", value: 5 },
        { title: "Mês", titleSize: "13", icon: "fa-solid fa-calendar-range", value: 6 },
        { title: "Ano", titleSize: "13", icon: "fa-solid fa-calendar-days", value: 7 },
      ],
    };
  },
  computed: {
    ...mapState("user", ["userLogged"]),
    ...mapGetters("generic", ["event"]),
    optionsWithByRules() {
      const displayPeriod = this.userLogged.parameterRental.displayPeriod;
      const options = [];
      this.options.forEach((item) => {
        if (!displayPeriod.includes(String(item.value))) return;
        options.push(item);
      });
      return options;
    },
  },
  methods: {
    ...mapActions("generic", ["postApi"]),
    ...mapMutations("generic", ["addEvent", "removeLoading"]),
    generate() {
      if (this.startDateHour) {
        this.generatePeriodRental.startDateHour = this.startDateHour;
      }
      const params = {
        url: this.urlGenerate,
        obj: this.generatePeriodRental,
        notNotifyToast: true,
        notRemoveFormDirty: true,
      };
      this.postApi(params).then((response) => {
        this.addEvent({ name: "generatePeriodRent", data: response.content });
        this.$emit("input", response.content);
        this.showPeriodRent = true;
        this.btnGenerateDisabled = true;
        this.removeLoading(["btnGeneratePeriodRent"]);
      });
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name === "periodRentCreateUpdate") {
          this.generatePeriodRental.multiplier = 1;
          this.showPeriodRent = false;
          this.btnGenerateDisabled = false;
        }
        if (event.name === "cleanGeneratePeriodRent") {
          this.generatePeriodRental = new GeneratePeriodRental();
          this.showPeriodRent = false;
        }
      },
      deep: true,
    },
    generatePeriodRental: {
      handler() {
        this.btnGenerateDisabled = false;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
/* Mantidos apenas estilos utilizados */
.period-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  min-height: 80px;
}

.period-row>div {
  margin-bottom: 10px;
}

.date-field-period {
  width: 170px;
  flex-shrink: 0;
  margin-top: 17px;
}

.increment-decrement {
  min-width: 120px;
}

.btn-generate {
  display: flex;
  align-items: center;
}

.div-period-rent {
  margin-bottom: 10px;
}
</style>
